import React from 'react';
import { Star } from 'lucide-react';
import { testimonials as fallbackTestimonials } from '../data/mock';
import { useContent } from '../hooks/useContent';

const BASE = process.env.REACT_APP_BACKEND_URL;
const resolveImg = (src) => (src && src.startsWith('/') ? `${BASE}${src}` : src);

export default function Testimonials() {
  const testimonials = useContent('testimonials', fallbackTestimonials) || fallbackTestimonials;
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto max-w-7xl px-4 md:px-8">
        <div className="text-center mb-12">
          <h2 className="text-sm font-bold text-secondary uppercase tracking-widest mb-2">Success Stories</h2>
          <h3 className="font-serif text-4xl md:text-5xl font-bold text-primary mb-4">What Our Students Say</h3>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Real experiences from Indian students currently studying MBBS in Russia through Russian Education.
          </p>
        </div>

        <div className="flex gap-6 overflow-x-auto pb-4 -mx-4 px-4 md:-mx-8 md:px-8 snap-x snap-mandatory scrollbar-hide">
          {testimonials.map((t, i) => (
            <div key={i} className="shrink-0 w-80 snap-start bg-muted/30 border border-border rounded-2xl p-6 flex flex-col gap-4 card-lift">
              <div className="flex gap-0.5">
                {Array.from({ length: 5 }).map((_, s) => (
                  <Star key={s} className="h-4 w-4 text-brand" fill="#FC2120" strokeWidth={0} />
                ))}
              </div>
              <p className="text-sm text-muted-foreground leading-relaxed flex-1">&ldquo;{t.quote}&rdquo;</p>
              <div className="flex items-center gap-3 pt-3">
                {t.photo ? (
                  <img src={resolveImg(t.photo)} alt={t.name} className="h-10 w-10 rounded-full object-cover shrink-0" />
                ) : (
                  <div className="h-10 w-10 rounded-full bg-primary text-white flex items-center justify-center text-sm font-bold shrink-0">
                    {t.initials}
                  </div>
                )}
                <div>
                  <div className="font-semibold text-foreground text-sm">{t.name}</div>
                  <div className="text-xs text-muted-foreground">{t.year} · {t.uni}</div>
                  <div className="text-xs text-brand font-medium">{t.state}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
